import { createSelector } from 'reselect';

export const tableSettingSelector = createSelector(
  (state) => state && state.account && state.account.userTableSetting,
  (tableSettingSelector) => tableSettingSelector
);
export const userTicketTableFilterSelector = createSelector(
  (state) => state && state.account && state.account.userTableFilter,
  (userTicketTableFilterSelector) => userTicketTableFilterSelector
);
export const companySelector = createSelector(
  (state) => state && state.settings && state.settings.companies,
  (companySelector) => companySelector
);
export const availableCompaniesSelector = createSelector(
  (state) => state && state.settings && state.settings.availableCompanies,
  (availableCompaniesSelector) => availableCompaniesSelector
);
export const availableCompaniesStatusSelector = createSelector(
  (state) => state && state.settings && state.settings.availableCompaniesStatus,
  (availableCompaniesStatusSelector) =>
    availableCompaniesStatusSelector || 'idle'
);
export const licenseKeySelector = createSelector(
  (state) => state && state.settings && state.settings.licenseKey,
  (licenseKeySelector) => licenseKeySelector
);
export const licensePaymentsSelector = createSelector(
  (state) => state && state.settings && state.settings.licensePayments,
  (licensePaymentsSelector) => licensePaymentsSelector
);
export const licensePaymentsTotalSelector = createSelector(
  (state) => state && state.settings && state.settings.licensePaymentsTotal,
  (licensePaymentsTotalSelector) => licensePaymentsTotalSelector || 0
);
export const actualProjectionsSelector = createSelector(
  (state) => state && state.settings && state.settings.actualProjections,
  (actualProjectionsSelector) => actualProjectionsSelector
);
export const yearlyProjectionsSelector = createSelector(
  (state) => state && state.settings && state.settings.yearlyProjections,
  (yearlyProjectionsSelector) => yearlyProjectionsSelector
);
export const companyMembershipsSelector = createSelector(
  (state) => state && state.settings && state.settings.companyMemberships,
  (companyMembershipsSelector) => companyMembershipsSelector
);
export const masterAdminsLocationSelector = createSelector(
  (state) => state && state.settings && state.settings.masterAdmins,
  (masterAdminsLocationSelector) => masterAdminsLocationSelector
);
